function vibezFormatMoney(cents, format) {
  var amount = (cents / 100).toFixed(2);
  var noDecimals = String(Math.round(cents / 100));
  return format
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
    .replace(/\{\{\s*amount\s*\}\}/g, amount);
}

function vibezUpdateCardPrice(cardOrPrice, variant) {
  // Accept either a wrapper element (card) or the .price element itself
  var priceContainer = (cardOrPrice && cardOrPrice.classList && cardOrPrice.classList.contains('price'))
    ? cardOrPrice
    : (cardOrPrice ? cardOrPrice.querySelector('.price') : null);
  if (!priceContainer || !priceContainer.dataset.moneyFormat) return;
  var moneyFmt = (priceContainer.dataset.currencyEnabled && priceContainer.dataset.moneyFormatCurrency)
    ? priceContainer.dataset.moneyFormatCurrency
    : priceContainer.dataset.moneyFormat;
  var newPrice = vibezFormatMoney(variant.price, moneyFmt);
  var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
  priceContainer.querySelectorAll('.change-price').forEach(function(el) {
    el.textContent = newPrice;
  });
  var compareEl = priceContainer.querySelector('s.price-item--regular');
  if (compareEl) {
    if (isOnSale) {
      compareEl.textContent = vibezFormatMoney(variant.compare_at_price, moneyFmt);
      compareEl.style.display = '';
    } else {
      compareEl.textContent = '';
      compareEl.style.display = 'none';
    }
  }
  priceContainer.classList.toggle('price--on-sale', !!isOnSale);
}

function getFocusableElements(container) {
  if(container){
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
}



document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if(window.innerWidth > 750){
    if(summary.closest('header-menu')){
      summary.closest('details').addEventListener('mouseenter', (event) => {
        const detailsElement = event.currentTarget;
          if (!detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.setAttribute('open', 'true');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'true');
          }
        
      });
      
      summary.closest('details').addEventListener('mouseleave', (event) => {
        const detailsElement = event.currentTarget;
          if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.removeAttribute('open');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'false');
          }
      });
    }
  }
  
  summary.addEventListener('click', (event) => {
    
    if (summary.classList.contains('matat_filters__summary')) {
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".matat-filter-body details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }

      // Price slider re-init is handled by matat-filter.js click listener
      
      }
      if(summary.closest('.product__accordion')){ 
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
      }
     const _headerSearchDetails = document.querySelector(".header__search details");
      if(_headerSearchDetails && _headerSearchDetails.hasAttribute("open")){
        _headerSearchDetails.removeAttribute("open")
      }
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.textContent = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.textContent = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {      
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    this.loadContent();
  }

  loadContent(focus = true) {
  }
}

customElements.define('deferred-media', DeferredMedia);

document.body.addEventListener('click', function (e) {
    let target = e.target;
    if(target.classList.contains('custom_variation_button')) {
      let find_quick_btn = target.closest('.product-card-wrapper').querySelector("modal-opener");
      if(find_quick_btn){
        let updated_url = target.closest("label").getAttribute("data-variant-url");
        find_quick_btn.querySelector("button").setAttribute('data-product-url', updated_url);
      }
      const parentItem = target.closest('.product-card-wrapper').querySelector('.product-card_inline-variation').querySelector('.product-form__input.listen_color_change');
      if (!parentItem) return;
      const actual_var_item = parentItem.querySelector('[value="'+target.value+'"]');
      if (!actual_var_item) return;
      actual_var_item.checked = true;
      parentItem.dispatchEvent(new CustomEvent('color_change',{'detail': target.value}));
      actual_var_item.dispatchEvent(new Event('custom_change'));
    }
    if(target.closest('variant-radios') && target.closest('.product-card-wrapper')) {
      if(target.tagName.toUpperCase() == 'INPUT') {
        target.closest('variant-radios').dispatchEvent(new Event('change'));
      }
    }
});

/**
 * initProductCardSwipers — initialises Swiper on every product card image
 * carousel that has not yet been set up. Safe to call multiple times (cards
 * added after a filter update, predictive-search results, etc.).
 */
function initProductCardSwipers() {
  document.querySelectorAll('.product-card-swiper').forEach(function(el) {
    if (el.swiper) return;
    new Swiper(el, {
      loop: false,
      slidesPerView: 1,
      speed: 300,
      allowTouchMove: true,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-button-disabled',
      },
    });
  });
}
document.addEventListener('DOMContentLoaded', initProductCardSwipers);


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".quick_add_cart .variant-button");
  if (!btn) return;

  const input = btn.querySelector("input.select_color");
  const tooltip = btn.querySelector(".variant-tooltip");

  if (input && tooltip) {
      tooltip.classList.add("show-tooltip"); // your custom class
      // Remove class after 2 seconds
      setTimeout(() => {
          tooltip.classList.remove("show-tooltip");
      }, 2000);
  }
});

// Add to Cart button on color-only products: show tooltip every click until color is selected
document.addEventListener("click", function(e) {
  const btn = e.target.closest(".default_variant_card .variant-button");
  if (!btn) return;

  const variantRadios = btn.closest('variant-radios');
  if (!variantRadios) return;

  const colorFieldset = variantRadios.querySelector('.product-form__input.listen_color_change');
  if (!colorFieldset) return;

  // If color is already selected, let quickAddToCart handle the submit normally
  if (colorFieldset.querySelector(':checked')) return;

  const tooltip = btn.querySelector('.variant-tooltip');
  if (!tooltip) return;

  // Clear any running timer and restart so rapid clicks always show for a full 2 s
  clearTimeout(btn._tooltipTimer);
  tooltip.classList.remove('show-tooltip');
  void tooltip.offsetWidth; // force reflow to restart transition
  tooltip.classList.add('show-tooltip');
  btn._tooltipTimer = setTimeout(() => tooltip.classList.remove('show-tooltip'), 2000);
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    if (this._vibezListenersBound) return;
    this._vibezListenersBound = true;

    if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
      const listenColorField = this.querySelector('.product-form__input.listen_color_change');
      if(listenColorField) {
        listenColorField.addEventListener('color_change', (e) => {
          const hasImageSwitcher = !!this.querySelector('.product-form__input.image_switcher_activated');

          // ── Image switching (only when enabled via theme setting) ──
          if (hasImageSwitcher) {
            const variant_image = this.updateSingleMedia(e.detail);
            if(e.target.closest(".card__inner").querySelector(".card__media").classList.contains("enable_image_slider")){
              if(variant_image){
                const cardMedia = e.target.closest(".card__inner").querySelector(".card__media");
                // Normalise URLs: strip protocol (https: vs //) and query string (?width=...) before comparing
                const norm = url => url.replace(/^https?:\/\//, '//').split('?')[0];
                const variantBase = norm(variant_image);
                const imgEl = [...cardMedia.querySelectorAll('.swiper-slide.pro-media img')]
                  .find(img => norm(img.getAttribute('src') || '') === variantBase);
                if (imgEl) {
                  const swiperSlide = imgEl.closest('.swiper-slide.pro-media');
                  const swiperEl = cardMedia.querySelector('.product-card-swiper');
                  if (swiperSlide && swiperEl && swiperEl.swiper) {
                    swiperEl.swiper.slideTo(parseInt(swiperSlide.dataset.index) || 0);
                  }
                }
              }
            } else {
              if(variant_image){
                this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
                this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
              }
            }
          }

          // ── Hover image + price (always, independent of image-switcher setting) ──
          var singleVariant = this.getVariantData().find(function(v){ return v.title.includes(e.detail); });
          if (singleVariant) {
            if (singleVariant.featured_image) {
              var imagesDataEl = this.closest('.product-card-wrapper').querySelector('.product-images-data');
              if (imagesDataEl) {
                try {
                  var productImages = JSON.parse(imagesDataEl.textContent);
                  var nextImageUrl = productImages[singleVariant.featured_image.position];
                  var hoverImg = this.closest('.product-card-wrapper').querySelector('img.card__hover-img');
                  if (hoverImg && nextImageUrl) {
                    hoverImg.src = nextImageUrl;
                    hoverImg.srcset = '';
                  }
                } catch(err) {}
              }
            }
            vibezUpdateCardPrice(this.closest('.product-card-wrapper'), singleVariant);
          }

          // ── Tooltip ──
          const card = this.closest(".card-wrapper");
          if (card) {
            card.querySelectorAll(".card__content .card-mobile-quickview")
              .forEach(el => el.classList.remove("select_color"));
          }

          // ── Variant button availability ──
          const variant_details = this.getVariantDetails(e.detail);
          const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
          var $this = this;
          $variant_input.forEach(function(input){
            input.classList.remove('select_color');
            var this_value = input.getAttribute('value');
            switch(input.getAttribute('data-option')) {
              case "1":
                var condition = variant_details.find((x)=>{ return x.available && x.option1 == this_value });
                $this.updateVariantButton(condition, input)
                break;
              case "2":
                var condition = variant_details.find((x)=>{ return x.available && x.option2 == this_value });
                $this.updateVariantButton(condition, input)
                break;
              case "3":
                var condition = variant_details.find((x)=>{ return x.available && x.option3 == this_value });
                $this.updateVariantButton(condition, input)
                break;
              default:
            }
          });
        });
      }
    }
    if(this.querySelector(".custom-select")){
      this.querySelectorAll(".custom-select .custom-selected").forEach((select_opt) => {
        select_opt.addEventListener("click", (e) => {
            e.target.nextElementSibling.classList.toggle("active");
        })
      })
      this.querySelectorAll(".custom-select .custom-select-options div").forEach((opt) => {
        opt.addEventListener("click", (optval) => {
          this.querySelectorAll(".custom-select .custom-select-options div").forEach((optremove) => {
            optremove.classList.remove("selected_val");
          });
          let $optvalue = optval.target.textContent;
          optval.target.closest(".custom-select").querySelector(".custom-selected span").textContent = $optvalue;
          optval.target.closest(".custom-select-options").classList.remove("active");
          optval.target.classList.add("selected_val");
          // change real select option
          let $s = optval.target.closest(".product-form__input--dropdown").getElementsByTagName("select")[0];
          let $sl = $s.length;
          for (let i = 0; i < $sl; i++) {
            if ($s.options[i].textContent == $optvalue) {
              $s.options[i].selected = true;
              $s.dispatchEvent(new Event("change", { bubbles: true }));
              break;
            }
          }
        })
      })
    }
  }

  updateVariantButton(condition, input){
    if(condition){
      input.classList.remove('disabled')
    }else{
      input.classList.add('disabled')
    }
  }

  onVariantChange(e) {
    const fieldset = e.target.querySelectorAll('fieldset');
    let checked_count = 0;
    fieldset.forEach((item)=>{
      if(item.querySelectorAll('input[type="radio"]:checked').length > 0) {
        checked_count++;
      }
    })
    if(checked_count < fieldset.length ) return;
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
          vibezUpdateCardPrice(this.closest('.product-card-wrapper'), this.currentVariant);
        }
        this.quickAddToCart();
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      
      if(e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
        // this.updateMedia(e.target.value);
        this.slideToSelectedVariant(e.target.value);
        
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  quickAddToCart() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      let enabledCounter = 0;
      const variant_form = this.querySelector('product-form').querySelector('form');
      let colorNotSelected = false;

    inputWrappers.forEach((option, index) => {
      const selectedOptionInput = option.querySelector(':checked');
      // Track whether the color fieldset has been selected
      if (option.classList.contains('listen_color_change') && !selectedOptionInput) {
        colorNotSelected = true;
      }
      if(selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
        enabledCounter++;
        if(enabledCounter == inputWrappers.length) {
          variant_form.dispatchEvent(new Event('submit'))
          this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
          this.closest('.product-card-wrapper').classList.add('adding_cart')
        }
      }
    });

    // For color-only products: show "please select a color" tooltip on the Add to Cart button
    if (colorNotSelected) {
      const defaultBtn = this.querySelector('.default_variant_card .variant-button');
      if (defaultBtn) {
        const tooltip = defaultBtn.querySelector('.variant-tooltip');
        if (tooltip) {
          tooltip.classList.add('show-tooltip');
          setTimeout(() => tooltip.classList.remove('show-tooltip'), 2000);
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  slideToSelectedVariant(color) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const target_variant = this.getVariantData().find(v => v.title.includes(color) && v.featured_media);
    if (!target_variant) return;
    const target_media_id = target_variant.featured_media.id;

    // Find the slide whose data-media-id ends with the variant's media id
    const allSlides = [...document.querySelectorAll('.Product_main_slider .swiper-wrapper > .product__media-item:not(.swiper-slide-duplicate)')];
    
    let slide = allSlides.find(s => {
      const mediaIdAttr = s.getAttribute('data-media-id');
      return mediaIdAttr && mediaIdAttr.endsWith(`-${target_media_id}`);
    });

    // Fallback if data-media-id wasn't available
    if (!slide) {
      const target_image = target_variant.featured_media.preview_image.src;
      slide = allSlides.find(s => s.querySelector(`a[href="${target_image}"]`) || s.querySelector(`a[href*="${target_image.split('?')[0]}"]`));
    }

    if (!slide) return;
    const idx = allSlides.indexOf(slide);
    const mainEl = document.querySelector('.product-slider-gallery.Product_main_slider');
    if (mainEl && mainEl.swiper) {
      if(mainEl.swiper.params.loop) {
        mainEl.swiper.slideToLoop(idx);
      } else {
        mainEl.swiper.slideTo(idx);
      }
    }
  }

  updateSingleMedia(color) {
    const single_variant_data = this.getVariantData().find(variant => variant.title.includes(color));
    return single_variant_data?.featured_image?.src ?? false;
  }

  getVariantDetails(color) {
    return this.getVariantData().filter(data=>data.title.includes(color));
  }

  updateURL() {
    const product_card = this.closest('.product-card_inline-variation');
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
    } else {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        if(document.querySelector(".product--giftcard")){
          document.querySelector(".product--giftcard").querySelectorAll(".price__container .price__regular .price-item--regular").forEach((e) =>{
            e.textContent = this.currentVariant.title;
          })
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // price change — update regular + compare-at price instantly
      var _cv = this.currentVariant;
      var _isOnSale = _cv.compare_at_price && _cv.compare_at_price > _cv.price;
      var _priceEl = document.querySelector('.product__info-wrapper .price');
      var _moneyFmt = _priceEl && _priceEl.dataset.moneyFormat;
      var _fmtPrice = _moneyFmt
        ? vibezFormatMoney(_cv.price, _moneyFmt)
        : ((_cv.price / 100).toFixed(0) + ' ₪');

      document.querySelectorAll('.product__info-wrapper .change-price').forEach(function(el) {
        el.textContent = _fmtPrice;
      });

      var _compareEl = document.querySelector('.product__info-wrapper s.price-item--regular');
      if (_compareEl) {
        if (_isOnSale) {
          _compareEl.textContent = _moneyFmt
            ? vibezFormatMoney(_cv.compare_at_price, _moneyFmt)
            : ((_cv.compare_at_price / 100).toFixed(0) + ' ₪');
          _compareEl.style.display = '';
        } else {
          _compareEl.textContent = '';
          _compareEl.style.display = 'none';
        }
      }

      if (_priceEl) _priceEl.classList.toggle('price--on-sale', !!_isOnSale);
    }
  }

  updateVariantStatuses() {
    const product_card = this.closest('.product-card_inline-variation');
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      if(inputWrappers[index - 1].querySelector(':checked')){
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
         const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
        if(product_card && option.classList.contains('visually-hidden')) {
          const colorSwatches = product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
          if (colorSwatches) {
            const optionInputsVariant = [...colorSwatches.querySelectorAll('input[type="radio"], option')];
            this.setInputAvailability(optionInputsVariant, availableOptionInputsValue);
          }
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    const product_card = this.closest('.product-card_inline-variation');

    if (!section || product_card) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const product_card = this.closest('.product-card_inline-variation');

    if(product_card) {
      // Variant data is already in memory — no page fetch needed for card context.
      // product-info / recipient-form variantChange subscribers only mount on the product page.
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    } else {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          // after innerHTML swap, sync price--on-sale on the inner .price element
          // (destination is the wrapper; the class lives on the inner .price div)
          var _destPrice = destination.querySelector('.price');
          var _srcPrice  = source.querySelector('.price');
          if (_destPrice && _srcPrice) {
            _destPrice.classList.toggle('price--on-sale',  _srcPrice.classList.contains('price--on-sale'));
            _destPrice.classList.toggle('price--sold-out', _srcPrice.classList.contains('price--sold-out'));
          }
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        //Sale Detected
        if(html.getElementById(`product-form-${this.dataset.section}`)){
          if(html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`)){
            const isSale = html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`);
            if(isSale){
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "inline-block";
            }else{
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "none";
            }
          }
        }
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = this.querySelector(`#product-form-${this.dataset.section}`)
      ?? document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (modifyClass) {
        const outOfStock = productForm.closest('.product')?.querySelector('.out-of-stock');
        if (outOfStock) {
          outOfStock.style.display = 'inline-block';
          if (document.querySelector('.backinstock_feature_enable')) {
            // The alert is absent on product pages where the TextMe app block owns the form,
            // so this must not throw and take the rest of the variant-change handler with it.
            addButton.closest('.product-form-main-container-outer').querySelector('.matat-backin-stock-alert')?.classList.add('active');
            addButton.classList.add('hidden');
            addButton.closest('.product-form-main-container-outer').classList.add('backinstock-active-main');
            addButton.closest('product-form').classList.add('backinstock-active');
          }
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (modifyClass) {
        const outOfStock = productForm.closest('.product')?.querySelector('.out-of-stock');
        if (outOfStock) {
          outOfStock.style.display = 'none';
          if (document.querySelector('.backinstock_feature_enable')) {
            // The alert is absent on product pages where the TextMe app block owns the form,
            // so this must not throw and take the rest of the variant-change handler with it.
            addButton.closest('.product-form-main-container-outer').querySelector('.matat-backin-stock-alert')?.classList.remove('active');
            addButton.classList.remove('hidden');
            addButton.closest('.product-form-main-container-outer').classList.remove('backinstock-active-main');
            addButton.closest('product-form').classList.remove('backinstock-active');
          }
        }
      }
    }
  }

  setUnavailable() {
    const button = this.querySelector(`#product-form-${this.dataset.section}`)
      ?? document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if(xx){
        if(xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")){
            xx.closest("fieldset").querySelector("legend span").textContent = xx.value;
          }
        return xx.value;
      }else{
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Fetch immediately instead of waiting for intersection
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.dispatchEvent(new CustomEvent('vibez:recommendations:loaded', {
          bubbles: true
        }));
      })
      .catch(() => {});
  }
}
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

// Product gallery mobile slider: handled by the inline Swiper init in product-media-gallery.liquid
if(document.querySelector(".matat-mobile-zoom-btn")){
  document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e) => {
    const activeImg = document.querySelector(".product__media-wrapper .swiper-slide-active img");
    if (activeImg) activeImg.click();
  });
}
  
if(document.querySelector(".backinstock_feature_enable")){

  // ── Back-in-stock: product page ──────────────────────────────────────────
  // buy-buttons ships the theme form inside an inert <template>. Where the TextMe restock app
  // block rendered (.stock-notifier-container) the app owns the form and the template is left
  // alone, so no theme markup reaches the DOM and the app's own #stock-phone lookups resolve to
  // its own fields. Everywhere else the template is stamped out here so the theme form keeps
  // working exactly as before: pre-order and gift card templates, featured product sections, and
  // the product page itself if the app is ever uninstalled or its block removed.
  document.querySelectorAll('.matat-backin-stock-template').forEach(template => {
    const scope = template.closest('.shopify-section') ?? document;
    if (scope.querySelector('.stock-notifier-container')) return;
    template.parentNode.insertBefore(template.content.cloneNode(true), template);
    template.remove();
  });

  if(document.querySelector(".single-main-product-page .matat-backin-stock-alert")){
    // Scope all queries to the BIS container so they never clash with
    // the quick-view modal (which uses its own BISfun() handler).
    const _bisAlert   = document.querySelector('.single-main-product-page .matat-backin-stock-alert');
    // buy-buttons renders the input as stock-phone-{{ section_id }}, so match on the prefix
    // rather than a bare #stock-phone, which never matched and left the form unsubmittable.
    const _phoneInput = _bisAlert?.querySelector('[id^="stock-phone"]');
    const _notifyBtn  = _bisAlert?.querySelector('.matat-stock-notify-submit');
    const _msgEl      = _bisAlert?.querySelector('#phoneValidationMsg');

    function validateBISPhone(value) {
      const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
      return pattern.test((value ?? '').trim());
    }

    // The submit button's data-* attributes are stamped by Liquid when the section renders, so
    // they only ever describe the page-load variant: data-variant-title was never refreshed, and
    // the data-id refresh hung off a "change" listener on [name="id"] that did not reliably fire.
    // Read the selection at submit time instead — the pickers expose the resolved variant, whose
    // title is guaranteed to match its id, and the theme keeps [name="id"] in sync as a fallback.
    function matatSelectedVariant(scope) {
      const picker = scope.querySelector('variant-radios, variant-selects');
      if (picker?.currentVariant) return picker.currentVariant;

      const variantId = (scope.querySelector('.product-variant-id') ?? scope.querySelector('[name="id"]'))?.value;
      if (!variantId) return null;

      const variantJson = picker?.querySelector('[type="application/json"]');
      if (!variantJson) return { id: variantId };
      try {
        const variants = JSON.parse(variantJson.textContent);
        return variants.find(variant => String(variant.id) === String(variantId)) ?? { id: variantId };
      } catch {
        return { id: variantId };
      }
    }

    _phoneInput?.addEventListener('keyup', (e) => {
      if (!e.target.value && _msgEl) _msgEl.textContent = '';
    });

    _notifyBtn?.addEventListener('click', () => {
      if (_msgEl) { _msgEl.textContent = ''; _msgEl.style.color = 'red'; }

      // Validate consent checkboxes (same global settings as newsletter)
      const checkboxes = _bisAlert?.querySelectorAll('.bis-consent-checkbox') ?? [];
      if (checkboxes.length && [...checkboxes].some(cb => !cb.checked)) {
        if (_msgEl) _msgEl.textContent = window.backInStockStrings?.checkboxError ?? '';
        return;
      }

      if (!validateBISPhone(_phoneInput?.value)) {
        if (_msgEl) _msgEl.textContent = window.backInStockStrings?.invalidPhone ?? '';
        return;
      }

      const _selected = matatSelectedVariant(_bisAlert.closest('.single-main-product-page') ?? document);

      const data = {
        phone:                    _phoneInput?.value ?? '',
        dialCode:                 '972',
        id:                       _selected ? String(_selected.id) : _notifyBtn.getAttribute('data-id'),
        product_id:               _notifyBtn.getAttribute('data-product_id'),
        action:                   _notifyBtn.getAttribute('data-action'),
        title:                    _notifyBtn.getAttribute('data-title'),
        price_varies:             JSON.parse(_notifyBtn.getAttribute('data-price_varies')),
        price:                    _notifyBtn.getAttribute('data-price'),
        price_max:                _notifyBtn.getAttribute('data-price_max'),
        price_min:                _notifyBtn.getAttribute('data-price_min'),
        has_only_default_variant: JSON.parse(_notifyBtn.getAttribute('data-has_only_default_variant')),
        src:                      _notifyBtn.getAttribute('data-src'),
        url:                      _notifyBtn.getAttribute('data-url'),
        user_id:                  _notifyBtn.getAttribute('data-user_id'),
        email:                    _notifyBtn.getAttribute('data-email'),
        full_name:                _notifyBtn.getAttribute('data-full_name'),
        variant_id:               _selected ? String(_selected.id) : _notifyBtn.getAttribute('data-variant-id'),
        variant_title:            _selected?.title ?? _notifyBtn.getAttribute('data-variant-title'),
      };

      fetch(`https://${Shopify.shop}/apps/text-me/restock-notifications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-shopify-shop-domain': Shopify.shop,
        },
        body: JSON.stringify(data),
      })
      .then(response => { if (!response.ok) throw new Error('Network response was not ok'); })
      .then(() => {
        if (_msgEl) {
          _msgEl.style.color = 'green';
          _msgEl.textContent = window.backInStockStrings?.successMessage ?? '';
        }
      })
      .catch(() => {
        if (_msgEl) {
          _msgEl.style.color = 'red';
          _msgEl.textContent = window.backInStockStrings?.errorMessage ?? 'An error occurred, please try again.';
        }
      });
    });

  }
// collection page back in stack
class BackinStockmatat extends HTMLElement{
  constructor() {
  super();
  this.addEventListener("click", () => {
    document.querySelector(".matat-product-card-stock").classList.toggle("active");
    document.body.classList.toggle("overflow-hidden");
    let $AllAttributes = this.attributes;
    this.copyAttributes($AllAttributes);
  })
}

copyAttributes(att){
  [...att].forEach((name) => {
    if(name.nodeName != "class"){
      document.querySelector("matat-stock-popup").setAttribute(name.nodeName,name.nodeValue);
    }
  })
}

}
customElements.define('matat-stock', BackinStockmatat);

// stock popup js starts from here
class matatStockPopup extends HTMLElement{
  constructor() {
    super();
    this.close = this.querySelector(".close-stock-popup");
    this.button = this.querySelector(".stock-popup-button");
    this.input = this.querySelector("#stock-phone-popup");
    this.close.addEventListener("click", () => {
      this.closest(".matat-product-card-stock").classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    })
    this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
    })
    this.addEventListener("click", (evt) => {
      if(evt.target == this){
        this.closest(".matat-product-card-stock").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      }
    })
  }

  validatePhoneNumber(number) {
    // Get and trim phone number input
    const phoneNumber = number.trim();
    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  submitStock(ele){
  document.getElementById('popup_phoneValidation').textContent = '';   
  let check_phone = this.validatePhoneNumber(this.input.value);
  if (check_phone) {
              // Get data attributes from the button
              const datas = this;
              const data = {
                  phone: this.input.value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: datas.getAttribute("data-id"),
                  product_id: datas.getAttribute("data-product_id"),
                  action: datas.getAttribute("data-action"),
                  title: (datas.getAttribute("data-title")),
                  price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
                  price: (datas.getAttribute("data-price")),
                  price_max: (datas.getAttribute("data-price_max")),
                  price_min: (datas.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
                  src: datas.getAttribute("data-src"),
                  url: datas.getAttribute("data-url"),
                  user_id: datas.getAttribute("data-user_id"),
                  email: datas.getAttribute("data-email"),
                  full_name: datas.getAttribute("data-full_name"),
                  variant_id: datas.getAttribute("data-variant-id"),
                  variant_title: datas.getAttribute("data-variant-title")
              };

              fetch(`https://${Shopify.shop}/apps/text-me/restock-notifications`, {
                  method: 'POST', 
                  headers: {
                      'Content-Type': 'application/json',
                      "x-shopify-shop-domain": Shopify.shop
                  },
                  body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      document.getElementById('popup_phoneValidation').textContent = window.backInStockStrings?.networkError ?? 'Network response was not ok';
                      setTimeout(function(){
                        document.querySelector(".matat-product-card-stock").classList.remove("active");
                        document.body.classList.remove("overflow-hidden");
                      }, 500);  
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('popup_phoneValidation').classList.add("sucess");
                this.displaySuccessMessage(window.backInStockStrings.successMessageShort);
                document.getElementById('popup_phoneValidation').textContent = window.backInStockStrings.successMessage;
                setTimeout(function(){
                  document.querySelector(".matat-product-card-stock").classList.remove("active");
                  document.body.classList.remove("overflow-hidden");
                }, 200);  
                
              })
              .catch(() => {});
      } else {
        document.getElementById('popup_phoneValidation').classList.remove("sucess");
          document.getElementById('popup_phoneValidation').textContent = window.backInStockStrings.invalidPhone;
      }
  }
  displaySuccessMessage(message) {
    this.displayAlertMessage(message, "success");
  }
  displayAlertMessage(message, type = "error") {
    const alertBox = document.createElement("div");
    alertBox.classList.add("alert-box", type);
    alertBox.textContent = message;

    document.body.appendChild(alertBox);

    setTimeout(() => {
        alertBox.remove();
    }, 5000); // Remove after 5 seconds
  } 
}
customElements.define('matat-stock-popup', matatStockPopup);

}


const toggleFocusClass = (e) => {
  if(e.target.closest(".floating_input_wrap")){
    e.target.closest(".floating_input_wrap").classList.toggle("focused", e.type === "focus");
  }
  if(e.type == "blur" && e.target.value != ""){
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.add("populated");
    }
  }else{
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.remove("populated");
    }
    
  }
};
document.querySelectorAll(".form-control").forEach((evt) => {
  evt.addEventListener("focus", toggleFocusClass);
  evt.addEventListener("blur", toggleFocusClass);
})
class GoogleLoginBtn extends HTMLElement{
  constructor() {
    super();
    this.querySelector(".google-button").addEventListener('click', () => {
      document.querySelector("#google-login").click();
    })
  }

}
customElements.define('button-google', GoogleLoginBtn);
document.addEventListener("click", (e) =>{
  if(e.target.classList.contains("modal-overlay") && e.target.closest("details").hasAttribute("open")){
      e.target.closest("details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
  }
  if(e.target.classList.contains("extra_color_button")){
    e.target.style.display = "none";
    e.target.closest(".card-variation-color").querySelectorAll(".color-hide-plus").forEach((ele) => {
      ele.classList.remove("color-hide-plus")
    })
  }

  if(e.target.classList.contains("mobile-popup-variant")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
    let $elementVariant = document.querySelector(`#${e.target.value}`);
    var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        $elementVariant.click();
        $elementVariant.dispatchEvent(evt);
  }
  if(e.target.classList.contains("product-vars-inner-main-popup")){
    e.target.classList.remove("active");
  }
  if(e.target.classList.contains("variant_popup_close_mobile") || e.target.closest(".variant_popup_close_mobile")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
  }
  // mobile quick view js starts from here
  if(e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")){
      const cardWrapper = e.target.closest(".card-wrapper");
        if (!cardWrapper) return;
        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
        quickAddButton?.click();
        
        const sizeFieldset = cardWrapper.querySelector(".product-card_inline-variation fieldset:not(.listen_color_change):not(.visually-hidden):not(.default_variant_card)");
        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
        if (sizeFieldset) {
          if (mobilePopupElement) {
            const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
            if (variationContainer) {
              mobilePopupElement.classList.add("active");
              variationContainer.innerHTML = '';
              sizeFieldset.querySelectorAll('input').forEach(function(input) {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.value = input.id;
                btn.className = 'mobile-popup-variant';
                btn.textContent = input.value;
                if (input.classList.contains('disabled')) btn.disabled = true;
                variationContainer.appendChild(btn);
              });
            }
          }
        } else {
          const defaultInput = cardWrapper.querySelector(".card__inner .product_quick_add_wrap .default_variant_card input[type='radio']");
          if (defaultInput) defaultInput.click();
        }
    }
  // ends here
})
document.addEventListener("DOMContentLoaded", (event) => {
    const _mobileSearchBtn = document.querySelector(".header-icon-search-mobile");
    if (_mobileSearchBtn) {
      _mobileSearchBtn.addEventListener("click", ()=>{
      const _searchDetails = document.querySelector(".header__search details");
      if(_searchDetails && _searchDetails.hasAttribute("open")){
        document.querySelector(".section-header").classList.remove("menu-open");
      }else{
        document.querySelector(".section-header").classList.add("menu-open");
      }
      const _menuDrawerContainer = document.querySelector("#Details-menu-drawer-container");
      if(_menuDrawerContainer && _menuDrawerContainer.hasAttribute("open")){
        _menuDrawerContainer.removeAttribute("open");
        _menuDrawerContainer.classList.remove("menu-opening");
        document.querySelector(".header__icon--menu")?.setAttribute("aria-expanded",false);
        document.body.classList.remove("overflow-hidden-tablet")
      }
      });
    }
   if(document.body.classList.contains("product-template")){
    function scrollToTop() {
      window.scrollTo(0, 0);
    }
      scrollToTop()
   }
});

// START Tooltip for mobile add to cart btn 
document.addEventListener("click", (e) => {
  const card = e.target.closest(".card-mobile-quickview.select_color")?.closest(".card-wrapper");
  const tooltip = card?.querySelector(".tooltip_text");
  if (!tooltip) return;

  tooltip.classList.remove("hidden");
  setTimeout(() => tooltip.classList.add("hidden"), 2000);
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.card__inner .variant-button input').forEach(function (input) {
    input.classList.remove('disabled');
  });
});
// END Tooltip for mobile add to cart btn

// START Set height of header and announcement bar
function setHeaderHeights() {
  const announcementBar = document.querySelector('.matat-announcement-bar-container');
  const header = document.querySelector('.section-header');
  const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  const headerHeight = header ? header.offsetHeight : 0;
  document.body.style.setProperty('--announcement-section-height', `${announcementHeight}px`);
  document.body.style.setProperty('--header-section-height', `${headerHeight}px`);
  // Toggle body class
  if (announcementBar && announcementHeight > 0) {
    document.body.classList.add('announcement-enabled');
  } else {
    document.body.classList.remove('announcement-enabled');
  }
}
// Run initially
window.addEventListener('load', () => {
  setHeaderHeights();
  // Observe DOM changes (for app-loaded announcement bar)
  const observer = new MutationObserver(() => {
    const announcementBar = document.querySelector('.matat-announcement-bar-container');
    if (announcementBar) {
      setHeaderHeights();
      // Optional: observe size changes too
      const resizeObserver = new ResizeObserver(() => {
        setHeaderHeights();
      });
      resizeObserver.observe(announcementBar);
      observer.disconnect(); // stop once found
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
// Recalculate on resize
window.addEventListener('resize', debounce(setHeaderHeights, 100));
// END Set height of header and announcement bar


// =============================================================================
// Vibez Swiper — global controller for vibez-media-grid, vibez-grid-products,
// and vibez-grid-collections sections.
//
// Each section encodes its own settings as data-* attributes at Liquid render
// time, so multiple instances of the same section type on one page are always
// fully independent — no shared state, no cross-section conflicts.
// =============================================================================
(function () {
  'use strict';

  // Selector map: section type → its Swiper / nav / pagination elements
  var TYPE_SELECTORS = {
    'media-grid': {
      swiper:     '.vibez-media-grid__swiper',
      next:       '.vibez-media-grid__next',
      prev:       '.vibez-media-grid__prev',
      pagination: '.vibez-media-grid__pagination'
    },
    'featured-products': {
      swiper:     '.vibez-featured-products__swiper',
      next:       '.vibez-featured-products__next',
      prev:       '.vibez-featured-products__prev',
      pagination: '.vibez-featured-products__pagination'
    },
    'featured-collections': {
      swiper:     '.vibez-featured-collections__swiper',
      next:       '.vibez-featured-collections__next',
      prev:       '.vibez-featured-collections__prev',
      pagination: '.vibez-featured-collections__pagination'
    }
  };

  // Cleanup registry: swiperEl → teardown function
  // WeakMap so entries are GC'd automatically when elements leave the DOM.
  var cleanupRegistry = new WeakMap();

  function parseBool(val) { return val === 'true' || val === true; }
  function parseNum(val)  { var n = parseFloat(val); return isNaN(n) ? 0 : n; }

  function getSettings(section) {
    var d = section.dataset;
    return {
      enableSliderDesktop:   parseBool(d.enableSliderDesktop),
      enableSliderMobile:    parseBool(d.enableSliderMobile),
      loopDesktop:           parseBool(d.loopDesktop),
      loopMobile:            parseBool(d.loopMobile),
      columnsDesktop:        parseNum(d.columnsDesktop),
      gapDesktop:            parseNum(d.gapDesktop),
      gapMobile:             parseNum(d.gapMobile),
      mobileLayout:          d.mobileLayout || 'auto',
      mobileSlideWidth:      parseNum(d.mobileSlideWidth),
      showArrowsDesktop:     parseBool(d.showArrowsDesktop),
      showArrowsMobile:      parseBool(d.showArrowsMobile),
      showPaginationDesktop: parseBool(d.showPaginationDesktop),
      showPaginationMobile:  parseBool(d.showPaginationMobile)
    };
  }

  function initVibezSwiperSection(section) {
    if (!section) return;

    var type = section.dataset.vibezSwiper;
    if (!type) return;

    var selectors = TYPE_SELECTORS[type];
    if (!selectors) return;

    var swiperEl = section.querySelector(selectors.swiper);
    if (!swiperEl) return;

    // Tear down any previous instance on this element before re-initialising
    if (cleanupRegistry.has(swiperEl)) {
      cleanupRegistry.get(swiperEl)();
      cleanupRegistry.delete(swiperEl);
    }

    // Per-section state lives entirely in this closure — isolated from every other section
    var SETTINGS   = getSettings(section);
    var slides     = swiperEl.querySelectorAll('.swiper-slide').length;
    var swiperInst = null;
    var lastMode   = null; // null = "never run yet"
    var resizeTimer;

    function buildConfig(mobile) {
      var perView    = mobile ? (SETTINGS.mobileLayout === 'auto' ? 1.5 : 'auto') : SETTINGS.columnsDesktop;
      var wantLoop   = mobile ? SETTINGS.loopMobile   : SETTINGS.loopDesktop;
      var minForLoop = typeof perView === 'number' ? Math.ceil(perView) + 1 : 3;
      var canLoop    = slides > minForLoop;

      return {
        loop:               wantLoop && canLoop,
        spaceBetween:       mobile ? SETTINGS.gapMobile : SETTINGS.gapDesktop,
        slidesPerView:      perView,
        slidesOffsetBefore: mobile ? SETTINGS.gapMobile : 0,
        slidesOffsetAfter:  mobile ? SETTINGS.gapMobile : 0,
        allowTouchMove:     true,
        navigation: (mobile ? SETTINGS.showArrowsMobile : SETTINGS.showArrowsDesktop)
          ? { nextEl: section.querySelector(selectors.next), prevEl: section.querySelector(selectors.prev) }
          : false,
        pagination: (mobile ? SETTINGS.showPaginationMobile : SETTINGS.showPaginationDesktop)
          ? { el: section.querySelector(selectors.pagination), clickable: true }
          : false
      };
    }

    function manage() {
      var mobile  = window.innerWidth <= 768;
      var doSlide = mobile ? SETTINGS.enableSliderMobile : SETTINGS.enableSliderDesktop;

      if (mobile === lastMode) return; // breakpoint unchanged — nothing to do
      lastMode = mobile;

      if (swiperInst) { swiperInst.destroy(true, true); swiperInst = null; }
      if (doSlide)    { swiperInst = new Swiper(swiperEl, buildConfig(mobile)); }
    }

    manage(); // initial run

    function handleResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(manage, 150); }
    window.addEventListener('resize', handleResize);

    // Store teardown so re-init is always clean
    cleanupRegistry.set(swiperEl, function () {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
      if (swiperInst) { swiperInst.destroy(true, true); swiperInst = null; }
    });
  }

  // Boot — works whether the script is deferred or loaded synchronously
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-vibez-swiper]').forEach(initVibezSwiperSection);
    });
  } else {
    document.querySelectorAll('[data-vibez-swiper]').forEach(initVibezSwiperSection);
  }

  // ─── Shopify Theme Editor ──────────────────────────────────────────────────
  // IMPORTANT: e.target on shopify:section:* events is the Shopify wrapper div
  //   <div id="shopify-section-XXXXX">  ← e.target
  //     <section data-vibez-swiper>     ← what we need
  //   </div>
  // So we must query *inside* e.target, not use it directly.

  function findVibezSection(wrapper) {
    return wrapper.querySelector('[data-vibez-swiper]');
  }

  function cleanupVibezSection(wrapper) {
    // Run teardown for any swiper that lives inside this wrapper
    Object.keys(TYPE_SELECTORS).forEach(function (type) {
      var swiperEl = wrapper.querySelector(TYPE_SELECTORS[type].swiper);
      if (swiperEl && cleanupRegistry.has(swiperEl)) {
        cleanupRegistry.get(swiperEl)();
        cleanupRegistry.delete(swiperEl);
      }
    });
  }

  // Settings changed or section added → re-init
  document.addEventListener('shopify:section:load', function (e) {
    cleanupVibezSection(e.target); // destroy old instance first (settings change replaces HTML)
    var sectionEl = findVibezSection(e.target);
    if (sectionEl) initVibezSwiperSection(sectionEl);
  });

  // Section selected in editor sidebar → re-init to ensure slider is live
  document.addEventListener('shopify:section:select', function (e) {
    var sectionEl = findVibezSection(e.target);
    if (sectionEl) initVibezSwiperSection(sectionEl);
  });

  // Section removed or replaced → clean up resize listeners
  document.addEventListener('shopify:section:unload', function (e) {
    cleanupVibezSection(e.target);
  });

})();


// ============================================================
// MEGA MENU — DESKTOP INTERACTIONS
// Controls: snippets/header-main-menu.liquid
// CSS:      base.css — MEGA MENU DESKTOP section
//
// Responsibilities:
//   1. Hover intent — open panel after 80ms, close immediately on leave
//   2. Sub Menu Item activation — hover or click based on data-submenu-trigger
//   3. Keyboard nav — Escape closes open panel
//   4. Theme editor — re-init on shopify:section:load
//
// Classes toggled:
//   .mega-menu-open     on <li.site-nav__item--has-mega> to show panel
//   .mega-menu__sub-nav-item--active  on sidebar labels (Block 3)
//   .mega-menu__sub-content--active   on content panels (Block 3)
// ============================================================

(function () {

  var HOVER_DELAY = 80; // ms before panel opens — prevents flicker on fast mouse-overs

  // ── Init ──────────────────────────────────────────────────────────────────

  function initMegaMenu() {
    var nav = document.querySelector('.site-nav--mega');
    if (!nav) return;

    var subTrigger = nav.dataset.submenuTrigger || 'hover';
    var navItems   = nav.querySelectorAll('.site-nav__item--has-mega');
    var timers     = {};

    navItems.forEach(function (item, idx) {
      var triggerLink = item.querySelector('.site-nav__link');

      // ── Open / close panel on hover ──────────────────────────────────────
      item.addEventListener('mouseenter', function () {
        timers[idx] = setTimeout(function () {
          closeAllPanels(navItems);
          openPanel(item, triggerLink);
        }, HOVER_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(timers[idx]);
        closePanel(item, triggerLink);
      });

      // ── Keyboard: Enter / Space toggles panel ────────────────────────────
      // Allows keyboard-only users to open/close the mega panel.
      if (triggerLink) {
        triggerLink.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (item.classList.contains('mega-menu-open')) {
              closePanel(item, triggerLink);
            } else {
              closeAllPanels(navItems);
              openPanel(item, triggerLink);
            }
          }
          // Arrow down moves focus into the first link in the panel
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            openPanel(item, triggerLink);
            var firstLink = item.querySelector('.mega-menu__panel a, .mega-menu__panel [role="tab"]');
            if (firstLink) firstLink.focus();
          }
        });
      }

      // ── Sub Menu Item sidebar activation (Block 3) ───────────────────────
      var subNavItems = item.querySelectorAll('.mega-menu__sub-nav-item');
      if (subNavItems.length > 0) {
        var eventType = subTrigger === 'click' ? 'click' : 'mouseenter';
        subNavItems.forEach(function (subItem) {
          subItem.addEventListener(eventType, function () {
            activateSubItem(item, subItem);
          });
          // Keyboard support for sidebar tabs (Arrow keys)
          subItem.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              activateSubItem(item, subItem);
            }
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
              e.preventDefault();
              var next = subItem.nextElementSibling;
              if (next && next.classList.contains('mega-menu__sub-nav-item')) {
                next.focus();
                activateSubItem(item, next);
              }
            }
            if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
              e.preventDefault();
              var prev = subItem.previousElementSibling;
              if (prev && prev.classList.contains('mega-menu__sub-nav-item')) {
                prev.focus();
                activateSubItem(item, prev);
              }
            }
          });
        });
      }

    });

    // ── Close on Escape ───────────────────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllPanels(navItems);
        // Return focus to the trigger link of whichever panel was open
        var openItem = nav.querySelector('.mega-menu-open .site-nav__link');
        if (openItem) openItem.focus();
      }
    });

    // ── Close when clicking outside nav ──────────────────────────────────────
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAllPanels(navItems);
    });
  }

  // ── Helpers ───────────────────────────────────────────────────────────────

  function openPanel(item, triggerLink) {
    item.classList.add('mega-menu-open');
    if (triggerLink) triggerLink.setAttribute('aria-expanded', 'true');
  }

  function closePanel(item, triggerLink) {
    item.classList.remove('mega-menu-open');
    if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
  }

  function closeAllPanels(navItems) {
    navItems.forEach(function (item) {
      var triggerLink = item.querySelector('.site-nav__link');
      closePanel(item, triggerLink);
    });
  }

  // Activate a Block 3 sidebar item and show its matching content panel
  function activateSubItem(parentItem, subItem) {
    var targetId = subItem.dataset.target;

    parentItem.querySelectorAll('.mega-menu__sub-nav-item').forEach(function (s) {
      s.classList.remove('mega-menu__sub-nav-item--active');
      s.setAttribute('aria-selected', 'false');
      s.setAttribute('tabindex', '-1');
    });

    parentItem.querySelectorAll('.mega-menu__sub-content').forEach(function (c) {
      c.classList.remove('mega-menu__sub-content--active');
      c.setAttribute('aria-hidden', 'true');
    });

    subItem.classList.add('mega-menu__sub-nav-item--active');
    subItem.setAttribute('aria-selected', 'true');
    subItem.setAttribute('tabindex', '0');

    var contentPanel = parentItem.querySelector('.mega-menu__sub-content[data-id="' + targetId + '"]');
    if (contentPanel) {
      contentPanel.classList.add('mega-menu__sub-content--active');
      contentPanel.setAttribute('aria-hidden', 'false');
    }
  }

  // ── Boot & theme editor re-init ───────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', initMegaMenu);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.site-nav--mega')) initMegaMenu();
  });

})();

// ============================================================
// MEGA MENU — DESKTOP END
// ============================================================


// ============================================================
// MEGA MENU — MOBILE INTERACTIONS
// Controls: snippets/header-drawer-matat.liquid
// CSS:      assets/mega-menu.css — sections 8–14
//
// Responsibilities:
//   1. initMobileCardSliders() — init Swiper on .mm-card-slider elements.
//      observer:true re-calculates layout when the hidden drawer opens.
//   2. initMobileAccordion() — smooth expand/collapse for .menu-toggle-button.
//      Uses actual scrollHeight so animation matches content height exactly.
//   3. Re-init on shopify:section:load for theme editor live preview.
// ============================================================

(function () {

  // ── Card Sliders (cards_with_links block) ─────────────────────────────────────────

  function initMobileCardSliders() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.mm-card-slider').forEach(function (el) {
      if (el.swiper) return;
      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
      });
    });
  }

  // ── Accordion Toggle (.menu-toggle-button) ─────────────────────────────────
  // Animates max-height from 0 → scrollHeight (open) and scrollHeight → 0 (close).
  // Double rAF on close ensures the browser paints the starting height before
  // the transition to 0 fires — avoids instant-collapse with no animation.

  function initMobileAccordion() {
    document.querySelectorAll('.menu-toggle-button').forEach(function (btn) {
      if (btn._mmAccordionBound) return;
      btn._mmAccordionBound = true;

      btn.addEventListener('click', function (e) {
        var subMenu = btn.querySelector('.sub-menu');
        if (!subMenu) return;
        if (subMenu.contains(e.target)) return; // ignore clicks on child links

        var isOpen = btn.classList.contains('sub-menu-open');
        if (isOpen) {
          subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              subMenu.style.maxHeight = '0';
            });
          });
          btn.classList.remove('sub-menu-open');
        } else {
          btn.classList.add('sub-menu-open');
          subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
          subMenu.addEventListener('transitionend', function onEnd() {
            subMenu.removeEventListener('transitionend', onEnd);
            if (btn.classList.contains('sub-menu-open')) subMenu.style.maxHeight = 'none';
          });
        }
      });
    });
  }

  function initMobile() {
    initMobileCardSliders();
    initMobileAccordion();
  }

  document.addEventListener('DOMContentLoaded', initMobile);
  document.addEventListener('shopify:section:load', initMobile);

})();

// ============================================================
// MEGA MENU — MOBILE END
// ============================================================